<template>
  <div id="user-group-edit">
    <v-card
      :loading="loadingState"
      class="mb-3"
    >
      <v-card-title>
        {{cardTitle}}

        <v-spacer />

        <v-btn
          color="error"
          @click="deleteDialog = true"
          v-if="canRemove && userCanDelete"
          :disabled="loadingState"
        >Удалить</v-btn>
      </v-card-title>
    </v-card>

    <v-scroll-y-reverse-transition>
      <v-alert
        v-if="isCreateNew && !userCanCreate"
        type="error"
      >
        Нет доступа.
      </v-alert>

      <v-card
        v-else-if="entityData"
        class="mb-3"
      >
        <v-tabs
          v-model="currentTab"
          show-arrows
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            v-for="tab in tabs"
            :href="`#tab-${tab.index}`"
            :key="tab.index"
            :disabled="!tab.component"
          >
            {{tab.title}}
          </v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="currentTab"
          class="mt-3"
        >
          <v-tab-item
            v-for="tab in tabs"
            :key="tab.index"
            :value="`tab-${tab.index}`"
          >
            <v-card flat>
              <v-card-text>
                <component
                  ref="tabContent"
                  :is="tab.component"
                  :entity-data="entityData"
                  v-bind="tab.props"
                  v-model="editInfo"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-scroll-y-reverse-transition>

    <v-scroll-y-reverse-transition>
      <entity-card-actions
        :saving="saving"
        :loading-state="loadingState"
        :can-save="isCreateNew ? userCanCreate : userCanUpdate"
        @save="saveItem"
        @saveAndClose="saveAndClose"
        @close="close"
        v-if="entityData"
      />
    </v-scroll-y-reverse-transition>

    <delete-gym-problem-dialog
      v-model="deleteDialog"
      :entity-id="$route.params.id"
      @deleted="handleDeleted()"
      v-if="canRemove && userCanDelete"
    />
  </div>
</template>

<script>
import {
  EditGymProblem,
  EditGym,
  EditWorkout
} from "@/components/gymProblem/edit";
import { DeleteGymProblemDialog } from "@/components/gymProblem/Dialogs";
import { EntityCard } from "@/mixins";

export default {
  mixins: [EntityCard],

  components: {
    EditGymProblem,
    EditGym,
    EditWorkout,
    DeleteGymProblemDialog
  },

  data: () => ({
    notFoundMessage: "Состояние зала не найдено.",
    updateonly: true,
    useFormData: true,

    /**
     * Поля, в которых содержатся файлы.
     */
    fileFields: {
      photos: "sync"
    },

    // API
    apiEntityName: "gymProblem",
    apiFetchMethodName: "gymProblem",
    apiUpdateMethodName: "updateGymProblem",

    // Router
    routerIndexName: "GymProblemIndex",
    routerEditName: "GymProblemEdit",

    policyKey: "gym_problem_policy"
  }),

  computed: {
    cardTitle() {
      return this.dbData ? `Проблема #${this.dbData.id}` : "Загрузка...";
    },

    tabs() {
      return [
        {
          index: 1,
          title: "Основное",
          component: "EditGymProblem"
        },
        {
          index: 2,
          title: "Зал",
          component: "EditGym"
        },
        {
          index: 3,
          title: "Тренировка",
          component: "EditWorkout"
        }
      ];
    },

    canRemove() {
      return this.dbData && !this.isCreateNew;
    },

    deletedMessage() {
      return `Проблема #${this.dbData.id} удалена.`;
    }
  }
};
</script>